import React from "react";

const Button = ({ onClick, text, small, danger, icon, disabled }) => {
  return (
    <button
      type="button"
      className={`${small ? "hidden-sm-up btn-sm" : "hidden-xs-down"} btn ${danger ? "btn-danger" : "btn-primary"} ml-05 mr-0`}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
      {icon && <i className={`fa fa-${icon}`}></i>}
    </button>
  );
};

const PurchaseOrderByPriceHeader = ({ handlePurchaseOrderSubmit, disabled, isMarketUser }) => {
  return (
    <div className="card">
      <div className="row">
        <div className="col-sm-12">
          <div className="card-header-grey d-flex justify-content-between align-items-center">
            <h4 className="pr-1 font-weight-medium no-margin-bottom">Select the items for your order</h4>
            <span className="d-flex">
              <Button disabled={disabled} onClick={handlePurchaseOrderSubmit} text={isMarketUser ? "Finish purchase" : "Wait purchase"} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderByPriceHeader;
